import SHOW_TOAST from "utils/showToast";
import { ENDPOINTS } from "utils/endpoints";
import { POST_API_CALL } from "utils/services";
import { EMPTY_AUTH, UPDATE_AUTH } from "store/actionTypes";
import { APIResponseModal, LoginFormModal } from "utils/modals";
import { toast } from "react-toastify";

export const loginManually = (data: LoginFormModal, callback: Function) => {
  return (dispatch: Function) => {
    const toastId = toast.loading("Login...");
    POST_API_CALL(ENDPOINTS.AUTH.LOGIN, data, (response: APIResponseModal) => {
      console.log("loginManually", response);
      if (response.isSuccess) {
        let dataToSave = response?.data?.result;
        const { message } = response?.data;
        const { token } = dataToSave;
        SHOW_TOAST(message, "success");
        sessionStorage.setItem("token", token);
        dispatch({
          type: UPDATE_AUTH,
          payload: { ...dataToSave, ...{ isSessionValid: true } },
        });
      }
      callback(response);
      toast.dismiss(toastId);
    });
  };
};

export const logoutManually = (callback: Function): Function => {
  return (dispatch: Function) => {
    POST_API_CALL(ENDPOINTS.AUTH.LOGOUT, {}, (response: APIResponseModal) => {
      console.log("logout Response :", response);
      if (response.isSuccess) {
        toast.success(response.data?.message);
        dispatch({ type: EMPTY_AUTH, payload: {} });
      }
      callback(response);
    });
  };
};
